import { ChangeDetectorRef, ChangeDetectionStrategy, Component, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormValueControl } from '@ppl/utils/form.utils';

@Component({
    selector: 'ppl-input-url',
    templateUrl: './input-url.component.html',
    styleUrls: ['./input-url.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PplInputUrlComponent),
            multi: true
        }
    ],
    standalone: false
})
@FormValueControl()
export class PplInputUrlComponent {

  @Input() value: string;
  @Input() disabled: boolean;
  @Input() showOpenUrl = true;

  @Output() valueChange = new EventEmitter<string>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  onValueChange(text: string) {
    this.valueChange.emit(text);
  }

  onButtonClick() {
    if (this.value) {
      const url = !this.value.match(/^[a-zA-Z]+:\/\//) ? 'http://' + this.value : this.value;
      try {
        window.open(url, '_blank');
      } catch (e) {
        console.log(`Couldn't open url: '${url}'. Error: ${e.message.trim()}`);
      }
    }
  }

}
